import { db } from '../firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

export const getFAQs = async () => {
  const q = query(collection(db, 'faqs'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data());
};

export const getTestimonials = async () => {
  const q = query(collection(db, 'testimonials'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data());
};

export const getCourseTestimonials = async () => {
  const q = query(collection(db, 'testimonials_course'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data());
};
